import { render } from "./DashboardBase.vue?vue&type=template&id=fe744d60"
import script from "./DashboardBase.vue?vue&type=script&lang=ts"
export * from "./DashboardBase.vue?vue&type=script&lang=ts"

import "./DashboardBase.vue?vue&type=style&index=0&id=fe744d60&lang=scss"
script.render = render

export default script